import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { CHECKOUT_WIZARD_STEP, useSurCheckoutWizard } from "@tSurya/Components/SurCheckoutWizardContext";
import React, { FC } from "react";
import { css } from "styled-components";
import { COLORS, TYPOGRAPHY } from "@tSurya/theme/design.surya";

const CartLineWhiteGloveService: FC = () => {
    const { goToStep } = useSurCheckoutWizard();
    const goToWhiteGloveStep = () => goToStep(CHECKOUT_WIZARD_STEP.ShippingMethod);

    return (
        <StyledWrapper
            onClick={goToWhiteGloveStep}
            onKeyDown={event => {
                if (event.key === "Enter" || event.key === " ") {
                    event.preventDefault();
                    goToWhiteGloveStep();
                }
            }}
            role="button"
            tabIndex={0}
            css={css`
                cursor: pointer;
                font-family: ${TYPOGRAPHY.fontFamily.title};
                font-style: italic;
                font-weight: ${TYPOGRAPHY.weight.mediumbold};
                font-size: ${TYPOGRAPHY.size.smaller};
                line-height: ${TYPOGRAPHY.lineHeight.base};
                color: ${COLORS.checkout.text.secondary};
                &:hover {
                    text-decoration: underline;
                }
            `}
        >
            White Glove Service
        </StyledWrapper>
    );
};

export default CartLineWhiteGloveService;
